import { array, number, partial, struct } from 'io-ts/Decoder';

import * as transaction from '../../transaction';
import { Area } from '../../ui/geometry';

import { Attachment } from './Attachment';
import { Links } from './Links';
import { Reactions } from './Reactions';

export const Metadata = partial({
	attachments: array(Attachment),
	links: Links,
	owners: partial({
		transactions: array(transaction.Id),
	}),
	reactions: Reactions,
	areas: struct({
		number: number,
		areas: array(Area),
	}),
});
